import React, { useEffect } from "react"
import { batch } from "@preact/signals-react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { offices ,officesOptions, reports, reportsInfo} from "@signals"
import { useSearchParams } from "react-router-dom"
import {resetCustomFilters} from "../../AnalyzersV2/@signals";


export default function ReportsAutocomplete({ ...props }) {
	const [searchParams] = useSearchParams()
	const { filters: filters = {}, ...restProps } = props;

	useEffect(() => {
		reports.value = searchParams.get('idReportExecution')
	}, [])

	return  <AutocompleteAjaxSeeker
			filterSelectedOptions={false}
			fullWidth
			label="Reports"
			placeholder="Please, select a report"
			value={reports.value}
			filters={{
				...filters,
				idReportExecution: reports.value,
				idOfficePickup: offices.value,
				...props.directsite != null && {getDirectSites: props.directsite}

			}}
			urlAjax={`${BACKEND_APIS.EXECUTION_INFO}/last_executions`}
			onFinishAjax={options => {
				reportsInfo.value = options
				const result = options.find(item => item.value === reports.value)
				officesOptions.value = result ? result.offices : []
			}}
			onChange={e => batch(() => {
				resetCustomFilters()
				reports.value = e.target.value
			})}
			{...restProps}
		/>
}